import React, { useState } from "react";
import {
  Alert,
  AlertTitle,
  Backdrop,
  Box,
  Button,
  Chip,
  Divider,
  Menu,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import axios from "../../api/PrivateApi";
import ViewPDF from "../../components/1000/ViewPDF";
import useAuth from "../../hooks/useAuth";

const researchDetailLabelStyle = {
  textTransform: "none",
  fontWeight: "bold",
  color: "rgba(17, 24, 71, 1)",
};

const researchDetailDataStyle = {
  display: "inline-block",
  fontWeight: "normal",
  overflow: "hidden",
  position: "absolute",
  maxWidth: "36%",
  marginLeft: "5px",
};

const ResearchDetail = React.forwardRef(
  ({ researchId, closeResearchDetail, closeDetail }, ref) => {
    const [result, setResult] = useState({});
    const [staffInResearch, setStaffInResearch] = useState([]);
    const [detailType, setDetailType] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [reason, setReason] = useState({ reason: "" });
    const [extension, setExtension] = useState(false)
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { user, changed } = useAuth();
    const staffActionBtnOpen = Boolean(anchorEl);

    // useEffect(() => {
    //   const isExtension = async () => {
    //     const res = await axios(`research/isExtension/${researchId}`)
    //     setExtension(res.data.isExtension)
    //   }
    //   isExtension()
    // })

    useEffect(() => {
      const fetchData = async () => {
        const res = await axios(`research/detail/${researchId}`);
        const extend = await axios(`research/isExtension/${researchId}`)
        setExtension(extend.data.isExtension)
        console.log('extend: ', extend)
        const staff = [];
        setResult(res.data[0]);
        setDetailType(res.data[0].status);
      };
      fetchData();
    }, [researchId]);

    const handleRejectBtnClick = async (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleRejectPopupClose = () => {
      setAnchorEl(null);
    };
    const handleAcceptResearchRequest = async () => {
      if (extension) {
        const res = await axios.post(`research/approveExtension/${researchId}`)
      }
      else {
        const res = await axios.post(`research/approve/${researchId}`);
      }
    };

    // const handleRejectResearchRequest = async () => {
    //   const res = await axios.post(`research/reject/${researchId}`);
    // };

    const onSubmit = async (e) => {
      e.preventDefault();
      console.log("submitting!!!");
      const res = await axios.post(`research/reject/${researchId}`, {
        reason: reason.reason,
      });
      console.log("jackbauer");
      handleRejectPopupClose();
      closeResearchDetail();
    };

    const onReasonChange = (e) => {
      setReason({ reason: e.target.value });
    };

    const statusStyle = () => {
      let string = "";
      let color = "";

      switch (result.status) {
        case "Extended":
          string = "Extended";
          color = "blue";
          break;
        case "Pending":
          string = "Pending";
          color = "blue";
          break;
        case "Active":
          string = "Active";
          color = "green";
          break;
        case "Rejected":
          string = "Rejected";
          color = "red";
          break;
        default:
          string = "Rejected";
          color = "red";
          break;
      }
      return [{ string: string }, { color: color }];
    };

    return (
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          paddingBottom: 5,
          width: 1000,
          bgcolor: "background.paper",
          border: "none",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          maxWidth: "85vw",
          height: "95vh",
          overflowY: "scroll",
          "&::-webkit-scrollbar": {
            width: "0.4em",
          },
          "&::-webkit-scrollbar-track": {
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0,0,0,.1)",
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            marginBottom: 1,
            color: "rgba(17, 24, 71, 0.8)",
            textAlign: "center",
          }}
          id="modal-modal-title"
          variant="h5"
          component="h2"
        >
          {detailType === "Pending" && !extension
            ? "Research Approval Request"
            : ""}
          {detailType === 'Pending' && extension
            ? 'Research Extension Request'
            : ""}
          {(detailType === 'Active' || detailType === 'Extended') && !extension
            ? 'Research Details'
            : ''}
        </Typography>
        <Typography
          sx={{
            fontWeight: "bold",
            marginBottom: 2,
            color: "rgba(143, 146, 168, 1)",
          }}
          id="modal-modal-title"
          variant="h6"
          component="h2"
        >
          Research Details
        </Typography>
        {/* left side research detail */}
        <Box
          sx={{
            display: "flex",
            boxShadow: 1,
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Box sx={{ width: "45%" }}>
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Title:{" "}
              <Tooltip placement="top" title={result.title}>
                <span style={researchDetailDataStyle}>{result.title}</span>
              </Tooltip>
            </Typography>
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Grant Code:{" "}
              <span style={researchDetailDataStyle}>{result.grant_code}</span>
            </Typography>{" "}
            {/* <br /> */}
            {/* <Typography variant="button" sx={researchDetailLabelStyle}>
              Staff Assigned:{" "}
              <span style={researchDetailDataStyle}>
                {staffInResearch.length}
              </span>
            </Typography>{" "} */}
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Type: <span style={researchDetailDataStyle}>{result.type}</span>
            </Typography>{" "}
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Institution:{" "}
              <span style={researchDetailDataStyle}>{result.institution}</span>
            </Typography>
          </Box>
          <Divider
            sx={{ fontSize: 24 }}
            orientation="vertical"
            flexItem
          ></Divider>
          {/* right side research detail */}
          <Box
            sx={{
              width: "45%",
              marginLeft: 2,
            }}
          >
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Start Date:{" "}
              <span style={researchDetailDataStyle}>{result.start_date}</span>
            </Typography>{" "}
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              End Date:{" "}
              <span style={researchDetailDataStyle}>{result.end_date}</span>
            </Typography>{" "}
            <br />
            {/* TODO: fix attachment to show/download the file  */}
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Attachement:{" "}
              <span style={researchDetailDataStyle}>
                {result.attachment === null ?
                  <span style={{ color: 'red' }}>no attachment</span> :
                  <Chip color='primary' size='small' label="View" onClick={() => setOpenBackdrop(true)} />}
              </span>
            </Typography>{" "}
            <br />
            <Typography variant="button" sx={researchDetailLabelStyle}>
              Status:{" "}
              <span
                style={{
                  ...statusStyle()[1],
                  ...researchDetailDataStyle,
                }}
              >
                {statusStyle()[0].string}
              </span>
            </Typography>{" "}
            <br />
          </Box>
        </Box>
        <Typography
          sx={{
            fontWeight: "bold",
            marginTop: 2,
            marginBottom: 2,
            fontSize: 16,
            color: "rgba(143, 146, 168, 1)",
          }}
          id="modal-modal-title"
          variant="h6"
          component="h2"
        >
          Summary
        </Typography>
        <Box
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            padding: 2,
          }}
        >
          <Typography sx={{ color: "rgba(17, 24, 71, 0.8)" }}>
            {result.summary}
          </Typography>
        </Box>

        {result.status === "rejected" ? (
          <div>
            <Typography
              sx={{
                fontWeight: "bold",
                marginTop: 2,
                marginBottom: 2,
                fontSize: 16,
                color: "rgba(143, 146, 168, 1)",
              }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Rejected Reason
            </Typography>
            <Box
              sx={{
                boxShadow: 3,
                borderRadius: 2,
                padding: 2,
              }}
            >
              <Typography sx={{ color: "rgba(17, 24, 71, 0.8)" }}>
                {result.reject_reason}
              </Typography>
            </Box>
          </div>
        ) : (
          ""
        )}

        {detailType === "Pending" ? (
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end"
            sx={{
              marginTop: 2,
            }}
          >
            <Button
              onClick={() => {
                handleAcceptResearchRequest();
                closeResearchDetail();
              }}
              variant="contained"
              color="primary"
              sx={{ height: 40, mr: 1 }}
            >
              {extension ? "Accept Extension" : "Accept Request"}
            </Button>
            <Button
              onClick={handleRejectBtnClick}
              variant="contained"
              color="error"
              sx={{ height: 40, mr: 1 }}
            >
              {extension ? "Reject Extension" : "Reject Request"}
            </Button>
            <Button
              onClick={closeDetail}
              variant="contained"
              sx={{
                height: 40,
                background: "rgba(140, 140, 140, 1)",
                "&:hover": {
                  background: "rgba(140, 140, 140, 0.8)",
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        ) : null}
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={staffActionBtnOpen}
          onClose={handleRejectPopupClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <form onSubmit={(e) => onSubmit(e)} method="POST">
            <Box
              sx={{
                paddingX: 4,
                width: 550,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                  marginBottom: 2,
                  textAlign: "center",
                }}
                variant="h5"
                color="primary"
              >
                Rejection Reason
              </Typography>
              <TextField
                onChange={(e) => onReasonChange(e)}
                id="reject_reason"
                label="Reason"
                placeholder="Reason of Rejection"
                name="reject_reason"
                multiline
                rows={7}
                sx={{ width: "100%" }}
              />
              <Button
                type="submit"
                variant="contained"
                color="error"
                sx={{ height: 40, mr: 1, my: 3 }}
              >
                Reject Request
              </Button>
            </Box>
          </form>
        </Menu>
        <Backdrop
          sx={{ color: '#fff' }}
          open={openBackdrop}
        >
          {
            result?.attachment ?
              <ViewPDF className="display" close={{ setOpen: setOpenBackdrop, host: "http://localhost:5000", attachment: result.attachment?.slice(1,), token: `?token=${user?.accessToken}` }} /> :
              <Alert severity="error" sx={{ width: "20%", fontSize: "16px" }}>
                <AlertTitle sx={{ fontSize: "20px" }}>Error</AlertTitle>
                File Not Found
              </Alert>
          }
        </Backdrop>
      </Box>
    );
  }
);

export default ResearchDetail;
